import moment from 'moment';
var $ = require('jquery');
export var filterByKey = function filterByKey(array, value, key) {
  return array.filter(key ? function (a) {
    return a[key] === value;
  } : function (a) {
    return Object.keys(a).some(function (k) {
      return a[k] === value;
    });
  });
};

// funzione per lo scroll forzato in alto
export var scrollToTop = function scrollToTop() {
  window.scrollTo(0, 0);
};

// FUNZIONE CHE RITORNA TRUE SE VALORE NULL
export var isValueNull = function isValueNull(value) {
  return ["", undefined, null, 0].indexOf(value) > -1 ? true : false;
};

// FUNZIONE CHE RITORNA TRUE SE VALORE NON NULL/PRESENTE
export var isValuePresente = function isValuePresente(value) {
  return ["", undefined, null, 0].indexOf(value) == -1 ? true : false;
};

// FUNZIONE CHE RITORNA TRUE SE VALORE E' UN NUMBER
export var isNumber = function isNumber(value) {
  if (typeof value !== 'number') {
    return false;
  }
  if (value !== Number(value)) {
    return false;
  }
  if (value === Infinity) {
    return false;
  }
  return true;
};
export var isString = function isString(value) {
  if (typeof value !== 'string' || value !== String(value)) {
    return false;
  }
  return true;
};

// export const getDescrProfilo = (listProfili: Array<any>, cod: string) => {
//   let ret = "";
//   listProfili.forEach((item: any) => {
//     if (cod == item.idProfilo)
//       ret = item.nome;
//   });
//   return ret;
// };

// close modal by id
export var closeModal = function closeModal(id) {
  var modal = $('#' + id);
  modal.removeClass('show');
  modal.css({
    display: 'none'
  });
  var body = document.getElementsByTagName("BODY")[0];
  body.classList.remove("modal-open");
  var backdrop = document.getElementsByClassName("modal-backdrop")[0];
  backdrop.parentNode.removeChild(backdrop);
  var el = Array.from(document.querySelectorAll(".getModal")).find(function (el) {
    return el.getAttribute("data-target") === '#' + id;
  });
  if (el) el.click();
};
export var closeModalCambioSoc = function closeModalCambioSoc(id) {
  var modal = $('#' + id);
  modal.removeClass('show');
  modal.css({
    display: 'none'
  });
  modal.removeAttr("role aria-modal");
  modal.attr("aria-hidden", true);
  var body = document.getElementsByTagName("BODY")[0];
  body.classList.remove("modal-open");
  var backdrop = document.getElementsByClassName("modal-backdrop")[0];
  backdrop.parentNode.removeChild(backdrop);
  var el = Array.from(document.querySelectorAll(".getModal")).find(function (el) {
    return el.getAttribute("data-target") === '#' + id;
  });
  if (el) el.click();
};

// open modal by id
export var openModalByID = function openModalByID(id) {
  var tempLink = document.createElement('BUTTON');
  tempLink.setAttribute('data-target', '#' + id);
  tempLink.setAttribute('data-toggle', 'modal');
  document.body.appendChild(tempLink);
  tempLink.click();
  tempLink.parentNode.removeChild(tempLink);
};
export var closeModalByID = function closeModalByID(id) {
  var modal = $('#' + id);
  modal.removeClass('show');
  modal.css({
    display: 'none'
  });
  var body = document.getElementsByTagName("BODY")[0];
  body.classList.remove("modal-open");
  body.removeAttribute('style');
  var backdrop = document.getElementsByClassName("modal-backdrop");
  if (backdrop != undefined && backdrop.length > 0) backdrop[0].remove();
};

/**
 * @description Passare come secondo parametro "F", se il campo è al femminile, di default è settato ad "M"
 */
export var getDescrInvalid = function getDescrInvalid() {
  var campo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var genere = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "M";
  return "Errore: inserisci " + (genere === "F" ? "una ".concat(campo, " valida") : "un ".concat(campo, " valido"));
};
export var getDescrRequired = function getDescrRequired() {
  var campo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return "Errore: il campo \"".concat(campo, "\" \xE8 obbligatorio");
};
export var getData = function getData(data) {
  // var sUsrAg = navigator.userAgent;
  // if (sUsrAg.indexOf("Trident") > -1) {
  var dataFormattata = moment(data).format('DD/MM/yyyy');
  return data && dataFormattata;
  // } else {
  //     const parseMonth = String(Number(new Date(data).getMonth()) + 1).padStart(2, '0')
  //     return data && new Date(data).getDate() + "/" + parseMonth + "/" + new Date(data).getFullYear()
  // }
};

// FUNZIONE CHE FA UN REPLACE DA PUNTO A VIRGOLA SOLO PER I DATI_VP_TYPE (dati con la virgola)
export var valueFromDotToComma = function valueFromDotToComma(oggetto, listaDatiToComma) {
  var valueString;
  listaDatiToComma.map(function (item) {
    if (['', null, undefined, 0, "0"].indexOf(oggetto[item]) === -1 && String(oggetto[item]).includes(".")) {
      valueString = String(oggetto[item]).replace(".", ",");
      oggetto[item] = valueString;
    }
  });
};

// FUNZIONE CHE FA UN REPLACE DA VIRGOLA A PUNTO SOLO PER I DATI_VP_TYPE (dati con la virgola)
export var valueFromCommaToDot = function valueFromCommaToDot(oggetto, listaDati_VP) {
  var valueString,
    replaceValue = "";
  listaDati_VP.map(function (item) {
    valueString = String(oggetto[item]);
    if (valueString.includes(",")) {
      replaceValue = valueString.replace(",", ".");
      oggetto[item] = Number(replaceValue);
    }
  });
};
export var currencyFormatIt = function currencyFormatIt(num) {
  if (isNumber(num)) {
    return parseFloat(num).toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ' €';
  } else {
    return num;
  }
};

/**
 *  1.000.000 > 1000000
 * simile a currencyUnformatIt ma gestice anche numeri superiori a 999.999
 * @param {*} val
 */
export var parseNumberIt = function parseNumberIt(val) {
  var thousandSeparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var decimalSeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  //è gia un numero
  if (typeof val !== 'string') {
    return val && parseFloat(val) || 0;
  }
  //opzionalmente permettiamo di usare separatori diversi da . e ,
  thousandSeparator = thousandSeparator || '.';
  decimalSeparator = decimalSeparator || ',';
  if (val) {
    val = val.split(thousandSeparator).join('').split(decimalSeparator).join('.');
    return parseFloat(val);
  }
  return 0;
};
export var valueMultiply100 = function valueMultiply100(oggetto, listaDati_VP) {
  listaDati_VP.forEach(function (item) {
    oggetto[item] = Number(oggetto[item]) * 100 || 0;
  });
};
export var valueDivide100 = function valueDivide100(oggetto, listaDati_VP) {
  listaDati_VP.forEach(function (item) {
    oggetto[item] = Number(oggetto[item]) / 100 || 0;
  });
};
export var getDescrizione = function getDescrizione(oggetto, lista) {
  var ret = "";
  lista.forEach(function (item) {
    if (oggetto == item.optionValue) ret = item.optionLabel;
  });
  return ret;
};